import type { MouseEvent, RefObject } from 'react';

/** Seconds to skip forward (right half) or backward (left half) on double-click — matches common YouTube-style behavior */
export const YOUTUBE_DOUBLE_CLICK_SKIP_SECONDS = 10;

/** Delay before treating an overlay click as play/pause, so double-click can cancel and seek instead */
export const YOUTUBE_OVERLAY_SINGLE_CLICK_MS = 280;

type SeekablePlayer = {
  getCurrentTime?: () => number;
  seekTo: (amount: number, type?: 'seconds' | 'fraction') => void;
};

export function applyYoutubeDoubleClickSeek(
  e: MouseEvent<HTMLDivElement>,
  playerRef: RefObject<SeekablePlayer | null>,
  duration: number
): void {
  const player = playerRef.current;
  if (!player) return;

  const rect = e.currentTarget.getBoundingClientRect();
  const isRightHalf = e.clientX - rect.left >= rect.width / 2;
  let current = 0;
  try {
    if (typeof player.getCurrentTime === 'function') {
      current = player.getCurrentTime() ?? 0;
    }
  } catch {
    current = 0;
  }
  const delta = isRightHalf ? YOUTUBE_DOUBLE_CLICK_SKIP_SECONDS : -YOUTUBE_DOUBLE_CLICK_SKIP_SECONDS;
  let next = current + delta;
  if (next < 0) next = 0;
  if (duration > 0 && next > duration) next = duration;
  try {
    player.seekTo(next, 'seconds');
  } catch {
    // ignore
  }
}
